import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import UsPage from "./pages/UsPage";
import VideosPage from "./pages/VideosPage";
import MusicPage from "./pages/MusicPage";
import Contact from "./pages/ContactPage";
import ScrollToTop from "./components/ScrollToTop";

const Router = ({ childProps }) => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home {...childProps} />} />

        <Route path="/nosotros" element={<UsPage {...childProps} />} />

        <Route path="/trabajadores-de-la-luz" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc7wjW4D6UTGivImNH2gAm7l"} title={"Trabajadores de la Luz"} />} />

        <Route path="/esenios-abuela-ana" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc4e6o_o0U-pvMOZ_CHSni8P"} title={"Abuela Ana"} />} />
        <Route path="/esenios-maria-magdalena" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc4z4PGh3G-3VtxT0QCrhZS7"} title={"María Magdalena"} />} />
        <Route path="/esenios-maria-madre" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc6VmP1cmGfeLjFZplJvgi-Z"} title={"María Madre"} />} />
        <Route path="/esenios-jeshua" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc4sEcz9LeCS3PRDW5oIhbHP"} title={"Jeshua"} />} />

        <Route path="/angeles-y-arcangeles/zadquiel" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc4uFVHUAU6fcjOiERnGWVHy"} title={"Arcángel Zadquiel"} />} />
        <Route path="/angeles-y-arcangeles/uriel" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc6HHUXfqWhU7Qs6rIu2k8ns"} title={"Arcángel Uriel"} />} />
        <Route path="/angeles-y-arcangeles/jofiel" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc4juUNy1vi2zZ9gRvsRkndq"} title={"Arcángel Jofiel"} />} />
        <Route path="/angeles-y-arcangeles/chamuel" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc7lnd6_Yb4OTB-RrYQjLViw"} title={"Arcángel Chamuel"} />} />
        <Route path="/angeles-y-arcangeles/rafael" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc6-kNUGHxlXYPnPCTgh0eIm"} title={"Arcángel Rafael"} />} />
        <Route path="/angeles-y-arcangeles/gabriel" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc7c1kryXM8mnkpWzz0-4kqm"} title={"Arcángel Gabriel"} />} />
        <Route path="/angeles-y-arcangeles/metatron" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc7RW1HtL_QNq657npq_tJ9T"} title={"Arcángel Metatron"} />} />
        <Route path="/angeles-y-arcangeles/miguel" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc4kda8aZOdFqFjcyNiL47Si"} title={"Arcángel Miguel"} />} />
        <Route path="/angeles-y-arcangeles/angeles" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc4AirNbtU9FgiKyud1rbXAa"} title={"Ángeles"} />} />

        <Route path="/gaia" element={<VideosPage {...childProps} playlist={"PLLu0z_Ocytc50F_QReWOmU_L42bvX-poM"} title={"Gaia"} />} />
        
        <Route path="/musica-mom" element={<MusicPage {...childProps} playlistId={"6tMCcn6SC9VOYeDBO8eqwf"} title="MOM" />} />
        <Route path="/musica-mantras" element={<MusicPage {...childProps} playlistId={"14qnv1ZxAzjUYSVDEU6R10"} title="MANTRAS" />} />
        <Route path="/musica-meditation" element={<MusicPage {...childProps} playlistId={"6WYXMM1sLOg3ObpbL6Fl5S"} title="MEDITATIONS" />} />

        <Route path="/contacto" element={<Contact {...childProps} />} />
      </Routes>
    </>
  );
};

export default Router;